import PropTypes from 'prop-types';

const LoyaltyPointsIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    viewBox="0 0 72 72"
    height="30"
  >
    <g fill={props.iconColor}>
      <path
        d={'M36.25,72 L35.75,72 C35.75,52.288 19.712,36.25 0,36.25 L0,35.75 C19.712,35.75 35.75,19.712 35.75,'
        + ' 0 L36.25,0C36.25,19.712 52.287,35.75 72,35.75 L72,36.25 C52.287,36.25 36.25,52.288 36.25,72'}
      />
    </g>
  </svg>
);

LoyaltyPointsIcon.propTypes = {
  className: PropTypes.string,
  iconColor: PropTypes.string,
};

LoyaltyPointsIcon.defaultProps = {
  className: '',
  iconColor: '#E5007D',
};

export default LoyaltyPointsIcon;
